@if(visibleContracts.length) {
  <table class="table table-hover">
    <thead>
      <tr>
        <th>Rabatter</th>
        <th>Rabattsats</th>
        <th>Startdatum</th>
        <th>Slutdatum</th>
        <th>Ägare</th>
        @if(isAdminOrPlanner) {
          <th colspan="2">Kontrakt-ID</th>
        }
      </tr>
    </thead>
    <tbody>
      @for(contract of visibleContracts; track $index) {
        @for(ycpDiscount of contract.discounts; track $index) {
          <tr
            class="pointer with-seperator"
            [ngClass]="{'inactive': contract.ended}"
            (click)="toggleExpanded(ycpDiscount.id)">
            <td>
              <div class="tab tab--small">
                <ul class="reset--list">
                  @for(discount_type of ycpDiscount.discount_types; track $index) {
                    <li>
                      {{convert(discount_type)}}
                    </li>
                  }
                </ul>
              </div>
            </td>
            <td>
              {{ycpDiscount.yclis?.length ? '' : ycpDiscount.discount_rate | percent: '1.0-2'}}
            </td>
            <td>
              {{ycpDiscount.start_date | date:'yyyy-MM-dd'}}
            </td>
            <td>
              {{ycpDiscount.end_date | date:'yyyy-MM-dd'}}
            </td>
            <td>
              {{contract.owner_name || 'Finns ej i WOO Manager'}}
            </td>
            @if(isAdminOrPlanner) {
              <td>
                {{contract.contract_id}}
              </td>
            }
            <td>
              @if(ycpDiscount.yclis?.length) {
                <button class="toggle-button">
                  <span class="chevron small text--info" [ngClass]="{'bottom': expandedDiscounts[ycpDiscount.id]}"></span>
                </button>
              }
            </td>
          </tr>
          @for(ycliDiscount of ycpDiscount.yclis; track $index) {
            <tr
            [ngClass]="{'inactive': contract.ended, 'text--strong': applicableYclis[ycliDiscount.id]}" >
            <td class="hidden-cell">
              @if(expandedDiscounts[ycpDiscount.id]) {
                <div [ngClass]="{'expanded': expandedDiscounts[ycpDiscount.id]}" [@verticalExpansion]>
                <!-- empty cell to align columns -->
                </div>
              }

            </td>
            <td class="hidden-cell">
              @if(expandedDiscounts[ycpDiscount.id]) {
                <div
                  [ngClass]="{'expanded': expandedDiscounts[ycpDiscount.id]}"
                  [@verticalExpansion]>
                {{ycliDiscount.discount_rate | percent: '1.0-2'}}
                </div>
              }

            </td>
            <td class="hidden-cell">
              @if(expandedDiscounts[ycpDiscount.id]) {
                <div
                [ngClass]="{'expanded': expandedDiscounts[ycpDiscount.id]}"
                [@verticalExpansion]>
              {{ycliDiscount.start_date | date:'yyyy-MM-dd'}}
              </div>
              }

            </td>
            <td class="hidden-cell">
              @if(expandedDiscounts[ycpDiscount.id]) {
                <div
                  [ngClass]="{'expanded': expandedDiscounts[ycpDiscount.id]}"
                  [@verticalExpansion]>
                {{ycliDiscount.end_date | date:'yyyy-MM-dd'}}
                </div>
              }

            </td>
            <td class="hidden-cell">
              @if(expandedDiscounts[ycpDiscount.id]) {
                <div
                  [ngClass]="{'expanded': expandedDiscounts[ycpDiscount.id]}"
                  [@verticalExpansion]></div>
              }
            </td>
            @if(expandedDiscounts[ycpDiscount.id]) {
            <td
              class="hidden-cell"
              [ngClass]="{'expanded': expandedDiscounts[ycpDiscount.id]}"
            ></td>
            }
          </tr>
          }
        }
      }

    </tbody>
  </table>
}

@if(!visibleContracts.length) {
  <p class="text--italic">Det finns inga upplagda</p>
}

